import "./App.css";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HomePage from "./Pages/HomePage";
import CartPage from "./Pages/CartPage";
import ProductPage from "./Pages/ProductPage";
import SigninPage from "./Pages/SigninPage";
import SignupPage from "./Pages/SignupPage";
import SearchPage from "./Pages/SearchPage";
import PaymentMethodPage from "./Pages/PaymentMethodPage";
import { NavDropdown, Navbar } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { useContext, useState, useEffect } from "react";
import { Store } from "./Store";
import { Container } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import ShippingAdressPage from "./Pages/ShippingAdressPage";
import PlaceOrderPage from "./Pages/PlaceOrderPage";
import OrderPage from "./Pages/OrderPage";
import OrderHistoryPage from "./Pages/orderHistoryPage";
import OrderListPage from "./Pages/OrderListPage";
import DashboardPage from "./Pages/DashboardPage";
import ProfilePage from "./Pages/ProfilePage";
import Button from "react-bootstrap/Button";
import { getError } from "./Util";
import axiosInstance from "./Util";
import SearchBox from "./Components/Searchbox";
import ShoppingCartIcon from "./Components/shoppingCart";
import ProtectedRoute from "./Components/ProtectedRoute";
import AdminRoute from "./Components/AdminRoute";
import ProductListPage from "./Pages/ProductListPage";
import ProductEditPage from "./Pages/ProductEditPage";
import UserEditPage from "./Pages/userEditPage";
import UserListPage from "./Pages/userListPage";
import Footer from "./Components/Footer";

function App() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { cart, userInfo } = state;
  const signoutHandler = () => {
    ctxDispatch({ type: "USER_SIGNOUT" });
    localStorage.removeItem("userInfo");
    localStorage.removeItem("shippingAdress");
    localStorage.removeItem("paymentMethod");
    window.location.href = "/signin";
  };

  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axiosInstance.get(`/api/products/categories`);
        setCategories(data);
      } catch (err) {
        toast.error(getError(err));
      }
    };
    fetchCategories();

    const handleScroll = () => {
      // Check if the user is scrolling up
      if (window.scrollY > lastScrollY && sidebarIsOpen) {
        setSidebarIsOpen(false); // Close sidebar when scrolling up
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY, sidebarIsOpen]);

  return (
    <BrowserRouter>
      <div
        className={
          sidebarIsOpen
            ? "d-flex flex-column site-container active-cont"
            : "d-flex flex-column site-container"
        }
      >
        <ToastContainer position='bottom-center' limit={1} />
        <header>
          <Navbar bg='dark' variant='dark' expand='lg' defaultExpanded>
            <Container>
              <Button
                variant='dark'
                onClick={() => setSidebarIsOpen(!sidebarIsOpen)}
              >
                <i className='fa fa-bars'></i>
              </Button>

              <LinkContainer to='/'>
                <Navbar.Brand className='golden'>ECOMMERCE KING</Navbar.Brand>
              </LinkContainer>
              <Navbar.Toggle aria-controls='basic-navbar-nav' />
              <Navbar.Collapse id='basic-navbar-nav'>
                <SearchBox />
                <Nav className='me-auto w-100 justify-content-end'>
                  <Link to='/cart' className='nav-link'>
                    <ShoppingCartIcon />
                    {cart.cartItems.length > 0 && (
                      <Badge pill bg='danger'>
                        {cart.cartItems.reduce((a, c) => a + c.quantity, 0)}
                      </Badge>
                    )}
                  </Link>
                  {userInfo ? (
                    <>
                      <LinkContainer to='/orderhistory'>
                        <Nav.Link className='text-white'>My Orders</Nav.Link>
                      </LinkContainer>
                      <NavDropdown
                        title={
                          <h5 className='text-white'>Hi, {userInfo.name}</h5>
                        }
                        id='basic-nav-dropdown'
                        className='dropdown-dark'
                      >
                        <LinkContainer to='/profile'>
                          <NavDropdown.Item className='dropdown-item-white'>
                            User Profile
                          </NavDropdown.Item>
                        </LinkContainer>
                        <NavDropdown.Divider />
                        <Link
                          className='dropdown-item dropdown-item-white'
                          to='#signout'
                          onClick={signoutHandler}
                        >
                          Sign Out
                        </Link>
                      </NavDropdown>
                    </>
                  ) : (
                    <>
                      <Link className='nav-link text-dark' to='/signin'>
                        <Button type='button' variant='primary'>
                          Sign In
                        </Button>
                      </Link>
                    </>
                  )}
                  {userInfo && userInfo.isAdmin && (
                    <NavDropdown
                      title={<h5 className='text-white'>Admin</h5>}
                      id='admin-nav-dropdown'
                      className='dropdown-dark'
                    >
                      <LinkContainer to='/admin/dashboard'>
                        <NavDropdown.Item className='dropdown-item-dark'>
                          Dashboard
                        </NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Divider />
                      <LinkContainer to='/admin/products'>
                        <NavDropdown.Item className='dropdown-item-white'>
                          Products
                        </NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Divider />
                      <LinkContainer to='/admin/orders'>
                        <NavDropdown.Item className='dropdown-item-white'>
                          Orders
                        </NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Divider />
                      <LinkContainer to='/admin/users'>
                        <NavDropdown.Item className='dropdown-item-white'>
                          Users
                        </NavDropdown.Item>
                      </LinkContainer>
                    </NavDropdown>
                  )}
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </header>
        <div
          className={
            sidebarIsOpen
              ? "active-nav side-navbar d-flex justify-content-between flex-wrap flex-column"
              : "side-navbar d-flex justify-content-between flex-wrap flex-column"
          }
        >
          <Nav
            className='flex-column text-dark w-100 p-3'
            style={{ backgroundColor: "#393D47", height: "100vh" }}
          >
            <Nav.Item>
              <h1 className='text-light'>Categories</h1>
            </Nav.Item>
            {categories.map((category) => (
              <Nav.Item key={category} className='my-2'>
                <LinkContainer
                  to={{ pathname: "/search", search: `?category=${category}` }}
                  onClick={() => setSidebarIsOpen(false)}
                >
                  <Nav.Link className='category-link'>
                    <span className='ms-2'>{category}</span>
                  </Nav.Link>
                </LinkContainer>
              </Nav.Item>
            ))}
          </Nav>
        </div>
        <main>
          <Container className='mt-3'>
            <Routes>
              <Route path='/product/:slug' element={<ProductPage />} />
              <Route path='/cart' element={<CartPage />} />
              <Route path='/search' element={<SearchPage />} />
              <Route path='/signin' element={<SigninPage />} />
              <Route path='/signup' element={<SignupPage />} />
              <Route
                path='/profile'
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route path='/placeorder' element={<PlaceOrderPage />} />
              <Route
                path='/order/:id'
                element={
                  <ProtectedRoute>
                    <OrderPage />
                  </ProtectedRoute>
                }
              ></Route>
              <Route
                path='/orderhistory'
                element={
                  <ProtectedRoute>
                    <OrderHistoryPage />
                  </ProtectedRoute>
                }
              ></Route>
              <Route path='/shipping' element={<ShippingAdressPage />}></Route>
              <Route path='/payment' element={<PaymentMethodPage />}></Route>
              {/* Admin Routes */}
              <Route
                path='/admin/dashboard'
                element={
                  <AdminRoute>
                    <DashboardPage />
                  </AdminRoute>
                }
              ></Route>
              <Route
                path='/admin/orders'
                element={
                  <AdminRoute>
                    <OrderListPage />
                  </AdminRoute>
                }
              ></Route>

              <Route
                path='/admin/products'
                element={
                  <AdminRoute>
                    <ProductListPage />
                  </AdminRoute>
                }
              ></Route>
              <Route
                path='/admin/product/:id'
                element={
                  <AdminRoute>
                    <ProductEditPage />
                  </AdminRoute>
                }
              ></Route>
              <Route
                path='/admin/users'
                element={
                  <AdminRoute>
                    <UserListPage />
                  </AdminRoute>
                }
              ></Route>
              <Route
                path='/admin/user/:id'
                element={
                  <AdminRoute>
                    <UserEditPage />
                  </AdminRoute>
                }
              ></Route>
              <Route path='/' element={<HomePage />} />
            </Routes>
          </Container>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
